import React, { useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

const Team = () => {
  
  const members = [
    {
      "avatar": "https://static.igem.wiki/teams/4154/wiki/assets/dr-babak.jpg",
      "name": "Dr. BABAK Maria",
      "fact": 'I am an Assistant Professor in the Department of Chemistry at the City University of Hong Kong. My research interests lie at the interface of chemistry, biology and medicine and focus on the discovery and preclinical development of anticancer drugs for resistant and aggressive cancers with limited treatment options. Together with Dr Matsuda, I designed the research project for iGEM competition and guided the team to test the anticancer activity of genetically engineered natural products. I coordinated the team to successfully manage research, public outreach and educational activities. My favourite part of the project was directing promotional video, that was so much fun!',
      "role": "Principle Coordinator",
      "major": null,
    },
    {
      "avatar": "https://static.igem.wiki/teams/4154/wiki/assets/drmatsuda.jpg",
      "name": "Dr. MATSUDA Yudai",
      "fact": 'I am an Assistant Professor in the Department of Chemistry at the City University of Hong Kong. I designed the research project for the iGEM competition and provided advice on experiments and analysis of the data. I was invited by a colleague of mine to participate in the competition (especially on the research design). Natural product research is facing a significant challenge: the difficulty of obtaining new metabolites using conventional approaches. Synthetic biology could offer an alternative approach to providing useful natural products in an efficient and sustainable manner and to generating "unnatural" natural products with desired properties. I hope that natural product diversity can be further expanded using synthetic biology approaches to give future drug leads and other functional molecules',
      "role": "Scientific Advisor",
      "major": null,
    },
    {
      "avatar": "https://static.igem.wiki/teams/4154/wiki/assets/delta.jpg",
      "name": "CHAN Tsz Ki - Delta",
      "fact": "My name is Delta. I am the instructor and a Research Assistant of our team, and I have participated in the 2020 & 2021 iGEM. I shared the competition experience and provided many valuable insights to our team. This year, I was in charge of the parts, safety forms, and research.",
      "major": null,
      "role": "Research Assistant",
    }, {
      "avatar": "https://static.igem.wiki/teams/4154/wiki/assets/ritvik.jpg",
      "name": "RAINA Ritvik",
      "fact": "My name is Ritvik Raina, and I am a year 4 Biomedical Engineering major with a passion for learning and discovery. I had wanted to participate in iGEM since 2018, before I entered university. I was part of the silver medalist CityU Team 2021.  But once was not enough, and I decided to come back this year as a student leader in our Outreach Team. I mainly planned and oversaw all the activities handled by the outreach team - social media pages, comic series, collaboration and partnership activities, human practice, and public outreach. I feel that there is a lot more emphasis on digital solutions to problems; the iGEM competition gives us the opportunity to not only think about and work on synbio solutions but also educate the general public about this field. I feel that whatever I  have learnt in the two years of this competition will stay with me lifelong.",
      "major":" Biomedical Engineering",
      "role": "Student Leader",
    },
    {
      "avatar": "https://static.igem.wiki/teams/4154/wiki/assets/bermet.png",
      "name": "ABYLOVA Bermet",
      "major":"Biomedical Engineering",
      "fact": "Hi everyone, thanks for surfing around and showing interest in our project! This is my first time participating in iGEM, and I find it super interesting! Deliverables enriched my knowledge in synthetic biology and natural product biosynthesis. The main reason why I decided to participate was my desire to become a part of a research team, which strives to find innovative solutions to make the lives of the needy better. I was responsible for the implementation of the wiki page, logo design, and promotional video. Since the wiki page is the main tool to tell the world about the project, our team carefully worked on each page’s content so that everyone could understand it and get an insight into what kind of anticancer properties the regular fungi, from miso soup, could have. Enjoy our website and project, and stay tuned via our Instagram!",
      "major": " Biomedical Engineering",
      "role": "Team member",    
    },
    {
      "avatar": "https://static.igem.wiki/teams/4154/wiki/assets/dasha-white-1.jpeg",
      "name": "AITKULOVA Dariia",
      "fact": "As a CityU iGEM team member, I was responsible for the logo as well as the website creation. I purely enjoyed working on those two significant parts. The idea of the logo for our “SeCure” team was made by me and Bermet, while we were also managing its realization. Meanwhile, the website work required our management and visualization skills to accessibly deliver the ideas to the backend developers. Overall, I am very thrilled to show you the website that you are now on as well as share it with the rest of the world. During this work, my main insight was that realization of a such big project is only possible with the help of the whole team, while any scientific progress is made only with the help of cohesion of people. Therefore, I am very honored to be part of our team as well as bring even minor changes to the world of synthetic biology and natural product biosynthesis.",
      "major": "Biomedical Engineering",
      "role": "Team member",
    }, {
      "avatar": "https://static.igem.wiki/teams/4154/wiki/assets/aquila.jpg",
      "name": "AU Sze Ching - Aquila",
      "fact": "My name is Aquila. I mainly participated in fungal transformation work. It is an honour to work in a team representing City University of Hong Kong in iGEM. I’ve learnt a lot while working with my fellow schoolmates, especially in laboratory practices, and there is even more to learn.",
      "major": " Chemistry",
      "role": "Team member",
    }, {
      "avatar": "https://static.igem.wiki/teams/4154/wiki/assets/hojung.jpg",
      "name": "CHOE Ho-Jung",
      "fact": "I mostly draw comics to introduce people to iGEM and our project. While drawing the comics, I was able to learn more about the skills that we have used for our project, such as polymerase chain reaction (PCR) and clustered regularly interspaced short palindromic repeats and CRISPR-associated protein 9 (CRISPR-Cas9). I heard from my friend that there is a competition called iGEM, and I searched about iGEM on the internet to learn more about it. I have seen the websites made by diverse universities that participated last year and found it very interesting and fun to collaborate with other people to not only do labwork but also make videos and make websites to show our project. I look forward to sharing our website with many people.",
      "major": " Chemistry",
      "role": "Team member",
    }
    , {
      "avatar": "https://static.igem.wiki/teams/4154/wiki/assets/jesslyn.jpg",
      "name": "GALUH Jesslyn Elvaretta",
      "fact": "Hi, I'm Jesslyn, a year-2 student majoring in Chemistry. I was responsible for outreach activities, specifically in integrated human practice, education, and partnership. I decided to participate in the 2022 iGEM Competition as it is a great learning opportunity for both scientific work and other soft skills, such as teamwork and communication. I am very excited that we can share the wonders of synthetic biology and our research project through this Wiki! ",
      "major": "Chemistry",
      "role": "",
    }, {
      "avatar": "https://static.igem.wiki/teams/4154/wiki/assets/annie.jpg",
      "name": "LEUNG Tsz Tung - Annie",
      "fact": "Hi, I am Annie, a year 4 student majoring in Chemistry. It is exciting to join an international science competition. Being a research team member, I have valuable opportunities to learn about synthetic biology and new laboratory techniques. Also, It is enjoyable to work with my excellent teammates and to share synthetic biology knowledge with the public.",
      "major": "Chemistry",
      "role": "Team member",
    }, {
      "avatar": "https://static.igem.wiki/teams/4154/wiki/assets/yaroslav-kraynik-1.jpeg",
      "name": "KRAYNIK Yaroslav",
      "fact": "During the competition, I was doing MTT of our anticancer drug. I am also focused on the hoodie design as well as the organisation of interviews with the professors. iGEM gave me chance to bring the idea, that might help hundreds of people, to life.  Always try to improve our world by helping people. Together we are invincible!",
      "major": "Biomedical Engineering",
      "role": "Team member",
    }, {
      "avatar": "https://static.igem.wiki/teams/4154/wiki/assets/sheryl.jpg",
      "name": "MAK Sau Yin - Sheryl",
      "fact": "Hi, I am Sheryl! I have contacted a Mushroom company to arrange a farm visit and interview in order to know more about fungi cultivation. I also prepared some questions for the Mushroom farm interview and public opinion survey. Joining iGEM is a precious experience as it is my first time getting in touch with Synthetic biology, and I am curious about it. Conducting experiments and performing scientific research, it gives me a chance to learn more about synbio.",
      "major": "Chemistry",
      "role": "Team member",
    }, {
      "avatar": "https://static.igem.wiki/teams/4154/wiki/assets/anosha.jpg",
      "name": "SHAHZAD Anosha",
      "fact": "My role within the CityU iGEM team was primarily outreach-focused. I was responsible for communications and organising events to ensure our team maximised its opportunity to collaborate internationally with experts and iGEM teams. To spread the recognition of iGEM and synthetic biology, I ran our CityU iGEM page to post content related to our experiences. I coordinated with the Waterloo iGEM team, TechChihuahua iGEM team, and NTHU_Taiwan iGEM team to collaborate on activities and coordinated with the CUHK-SBS team to initiate a human practices-focused partnership. The iGEM competition was a unique experience where I learned about drug discovery, genetic engineering, and synthetic biology. The opportunity allowed me to work with great professors and meet multiple experts who have made remarkable advancements in this field. iGEM motivated growth through the tumultuous months and the overall success. This competition was a cherishable experience.",
      "major": "Chemistry",
      "role": "Team member",
    }, {
      "avatar": "https://static.igem.wiki/teams/4154/wiki/assets/christina.jpg",
      "name": "TSOI Ching Ching - Christina",
      "fact": "It is my first time engaging in iGEM. With research teammates, I have done a presentation on the topic of CRISPR to provide teammates with more insights into CRISPR. Then, as an outreach team member, I joined the Symposium on Synthetic Biology held by HKUST and gave a presentation with my teammates. After the Symposium, we interviewed the other teams for their thoughts related to the Symposium. As our project is related to fungi, we have gone to a local mushroom farm, Urban Mushroom Farm, to interview the owner of the farm. As we want to raise people’s understanding of synthetic biology, we have held workshops on synthetic biology for high school students. I am also responsible for the contribution and partnership part of the webpage as well as the photo shoot of team members. Joining the iGEM competition is one of the wise choices I have made, as it gives me more perception of synthetic biology. It also helped me to step out of my comfort zone and improve my soft skills.",
      "major": "Biomedical Engineering",
      "role": "Team member",
    }, {
      "avatar": "https://static.igem.wiki/teams/4154/wiki/assets/charlotte.jpg",
      "name": "TSANG Cheuk Lok - Charlotte",
      "fact": 'My name is Tsang Cheuk Lok, a year four student majoring in Chemistry. The first time I heard about the iGEM competition was from my classmates. I joined the iGEM competition because I wanted to learn more about biology, including biological knowledge and research skills, not just Chemistry. In addition, I am interested in the topic of the iGEM project, on how we can extract anticancer potency from usual products like miso soup or soy sauce.',
      "major": "Chemistry",
      "role": "Team member",
    }
  ]

  const [currentMemeber, setCurrentMemeber] = useState(members[0]);
  return (
    <div className="team_page">
    <div className="team_page_top">
      <div className="left">
        <h1>
          WHO <span>WE</span> ARE
        </h1>
        <img  src={currentMemeber.avatar} alt="" />
        
      </div>
      <div className="right">
        <div className="name">
          {currentMemeber.name}
        </div>
        <div className="major">
          {currentMemeber.major?
            <>
              <strong style={{marginRight:10}}>
              MAJOR:
            </strong>
            <span style={{ color: '#7CAED4' }}>
              {currentMemeber.major}
            </span>
            
            </>:
            <>
              <strong style={{ marginRight: 10 }}>
                ROLE:
              </strong>
              <span>
                {currentMemeber.role}
              </span>
            </>
          }
          
        </div>
        <div className="fact">
            {currentMemeber.fact.substr(0,240)+"..."}
            
        </div>
      </div>
      
    </div>
    <div className="members_list">
          
        {
          members.map(member=>{
            
              return (
                <a onMouseEnter={() => setCurrentMemeber(member)} href="#" className="circle">
                  <img src={member.avatar} alt="" />
                </a>
              )
            
          })
        }
        
        
      </div>
      <div className="atribution">
        <h3 className="calend" style={{ marginBottom: 0}}>
          Members
        </h3>
        <div className="atribution_list">
          
          {
            members.map(member => {
              
              return (
                <div className="atribution_one">
                  <div className="left">
                    <img src={member.avatar} alt="" />
                    <p className="left_name">
                      {member.name}
                    </p>
                    <p className="left_major">

                      {member.major?
                      <>
                        <strong>
                          Major: 
                        </strong>

                        <span style={{ color: '#7CAED4',fontWeight:200 }}> {member.major}</span>
                      </>
                      :
                      <>
                        <strong >
                          Role: 
                        </strong>
                          <span style={{ color: '#7CAED4', fontWeight: 200 }}> {member.role}</span>
                      </>
                      }

                    </p>
                  </div>
                  <div className="right">
                    
                    <p className="right_info">
                      {member.fact}
                    </p>
                    
                  </div>
                </div>
              )

            })
          }


        </div>
      </div>
      
    </div>
  );
}

export default Team;
